import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Visvesvaraya_Phd_AdmissionELe from './Visvesvaraya_Phd_admissionEle'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission" />
            <Visvesvaraya_Phd_AdmissionELe />
        </>
    )
}

export default Main